/**
 * Permission codes the AI screens declare an interest in
 * (`internal/ai/permissions.go`, `models_c12_*.go`, design C12 §6.1).
 *
 * Two of these are an **SoD pair** and the screens honour it before the click:
 * `ai.capability.manage` ⊗ `ai.autonomy.manage`. Whoever sets a tolerance band
 * must not be the person who decides that band may be acted on unattended —
 * without the pair, one principal can widen a tolerance and delegate the
 * capability in two clicks and §4.7's whole gate structure is decoration.
 *
 * `ai.assistant.use` is the gate on the right rail's Assistant mode. It is
 * checked, never assumed: when AI is disabled at the instance the server mounts
 * no `ai.*` route at all, nobody holds the code, and the rail simply does not
 * offer the tab — which is §10.1's "hide, not error", reached by the same
 * mechanism every other module's nav uses rather than by a hardcoded flag.
 */

export const AI_PERMISSIONS = {
  assistantUse: 'ai.assistant.use',
  capabilityRead: 'ai.capability.read',
  capabilityManage: 'ai.capability.manage',
  autonomyManage: 'ai.autonomy.manage',
  recommendationRead: 'ai.recommendation.read',
  recommendationAct: 'ai.recommendation.act',
  agentRead: 'ai.agent.read',
  agentManage: 'ai.agent.manage',
  agentRun: 'ai.agent.run',
  backtestRead: 'ai.backtest.read',
  backtestRun: 'ai.backtest.run',
  anomalyRead: 'ai.anomaly.read',
  anomalyManage: 'ai.anomaly.manage',
} as const

export type AiPermission = (typeof AI_PERMISSIONS)[keyof typeof AI_PERMISSIONS]
